function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["isOpen", "onRequestClose"];
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.get-prototype-of.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/* eslint-disable react/prop-types */
import React from 'react';
import Modal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import { IeltsReviewWrapper } from "./style";
import Contents from "./Contents";
var modalStyle = {
  content: {
    bottom: 'auto',
    left: '50%',
    right: 'auto',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  },
  overlay: {
    /**
     * Need to set a zIndex here otherwise it defaults to 0.  A 0 zIndex will
     * sit below elements that have zIndex specified.  For example, sticky table
     * headers from ui-components have a zIndex of 2 which causes them to be
     * above the modal.
     *
     * This zIndex level matches the z-index for ui-component modals.
     * See: https://v4.mui.com/customization/z-index/#z-index
     *
     * Ideally we should refactor this modal to use the modal from ui-components
     * when we have time
     */
    zIndex: 1300
  }
};
var IeltsReview = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(IeltsReview, _React$PureComponent);
  var _super = _createSuper(IeltsReview);
  function IeltsReview(props) {
    var _this;
    _classCallCheck(this, IeltsReview);
    _this = _super.call(this, props);
    _this.focus = function () {
      if (_this.ref.current) _this.ref.current.focus();
    };
    _this.onAfterOpen = function () {
      ReactTooltip.rebuild();
      _this.focus();
    };
    _this.onKeyDown = function (event) {
      if (event.key === 'Enter') {
        _this.props.onSubmit();
      }
    };
    _this.ref = /*#__PURE__*/React.createRef();
    return _this;
  }
  _createClass(IeltsReview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      ReactTooltip.rebuild();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      ReactTooltip.rebuild();
      this.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isOpen = _this$props.isOpen,
        onRequestClose = _this$props.onRequestClose,
        props = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        style: modalStyle,
        onAfterOpen: this.onAfterOpen,
        ariaHideApp: false
      }, /*#__PURE__*/React.createElement(IeltsReviewWrapper, null, /*#__PURE__*/React.createElement(Contents, _extends({
        ref: this.ref
      }, props, {
        onKeyDown: this.onKeyDown
      }))));
    }
  }]);
  return IeltsReview;
}(React.PureComponent);
export default IeltsReview;